import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const separationAnxietyElementarySchool: BlogMetaData = {
  title: '母子分離不安が続く小学生への対応｜原因と家庭・学校でできること',
  description:
    '就学後も母子分離不安が続く小学生への対応を解説。未就学期との違い、学童期特有の原因、家庭でできる声かけ、登校しぶりとの関係、相談先までモンテッソーリ視点で整理します。',
  thumbnailUrl: '/img/blog-separation-anxiety-elementary-school.webp',
  filePath: buildBlogFilePath('separation-anxiety-elementary-school'),
  category: BLOG_CATEGORY.PARENTING,
};
